
let apis = {
  VERIFICATION_API : process.env.REACT_APP_VERIFICATION_API,
  UNIVERSAL_API : "https://www.universal-tutorial.com"
}

export default apis;